import { render, staticRenderFns } from "./Appointments.html?vue&type=template&id=447dff8b&external"
import script from "./Appointments.js?vue&type=script&lang=js&external"
export * from "./Appointments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports